import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageSEO from '../components/PageSEO';

export const AboutPage = () => {
  const values = [
    { title: "Güven", desc: "Her ilişkimizin ve her projemizin temelinde koşulsuz güven yer alır." },
    { title: "Kalite", desc: "Mühendislikte ve uygulamada en yüksek kalite standartlarını benimseriz." },
    { title: "Şeffaflık", desc: "Süreçlerimiz açık, iletişimimiz net ve anlaşılırdır." },
    { title: "Vizyon", desc: "Bugünü değil, geleceği inşa eden projeler geliştiririz." },
  ];

  return (
    <div data-testid="about-page" className="page-transition">
      <PageSEO
        title="Hakkımızda"
        description="VE PERA İnşaat'ın hikayesi, vizyonu ve değerleri. 15 yılı aşkın deneyimle güvenli yapılar ve değerli yaşam alanları üretiyoruz."
        path="/hakkimizda"
      />
      {/* Hero - Editorial style */}
      <section className="pt-32 lg:pt-40 pb-20 bg-[#f2f2f7]">
        <div className="container-wide">
          <div className="grid lg:grid-cols-12 gap-8">
            <div className="lg:col-span-8">
              <span className="overline mb-6 block">Hakkımızda</span>
              <h1
                className="text-[clamp(2.5rem,6vw,4.5rem)] leading-[1] tracking-[-0.03em] mb-8"
                style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
              >
                Geleceğin yaşam alanlarını
                <br />
                <span className="italic font-light text-[#8e8e93]">bugünden</span> tasarlıyoruz
              </h1>
            </div>
            <div className="lg:col-span-4 flex items-end">
              <p 
                className="text-[#8e8e93] leading-[1.9] text-[15px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                PERA İnşaat, yapı sektöründe mühendislik mükemmelliğini, estetik tasarımı ve uzun vadeli değer yaratmayı bir araya getiren vizyoner bir marka.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section - Full width image with overlay text */}
      <section className="relative">
        <div className="grid lg:grid-cols-2">
          {/* Image */}
          <div className="h-[60vh] lg:h-[90vh]">
            <img
              src="https://images.unsplash.com/photo-1769184613636-1b7ba2210932?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGdsYXNzJTIwZmFjYWRlJTIwc3VubnklMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzc1NDY1NTg5fDA&ixlib=rb-4.1.0&q=85"
              alt="Premium architecture"
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Content */}
          <div className="bg-[#1a1a1a] flex items-center p-8 lg:p-16 xl:p-24">
            <div>
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#f2f2f7]/70 mb-8 block" style={{ fontFamily: "var(--font-body)", fontWeight: 500 }}>Hikayemiz</span>
              <h2
                className="text-[clamp(1.75rem,3vw,2.5rem)] leading-[1.15] tracking-[-0.02em] text-[#f2f2f7] mb-8"
                style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
              >
                Güvenli, kalıcı ve değerli yaşam alanları yaratma hedefiyle yola çıktık.
              </h2>
              <div className="w-12 h-[1px] bg-[#d1d1d6]/30 mb-8"></div>
              <p 
                className="text-[#d1d1d6]/80 leading-[1.9] mb-6 text-[15px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                Her projemizde mühendislik mükemmelliğini, estetik tasarımı ve insan odaklı yaklaşımı bir araya getiriyoruz. Türkiye'nin en zorlu coğrafi koşullarında bile güvenle ayakta kalacak yapılar inşa ediyoruz.
              </p>
              <p 
                className="text-[#d1d1d6]/80 leading-[1.9] text-[15px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                Bugün Türkiye'de güçlü bir temel atarken, yarın uluslararası arenada da aynı kalite ve güven anlayışıyla projeler geliştirmeyi hedefliyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision - Side by side, no boxes */}
      <section className="section-padding bg-[#f2f2f7]">
        <div className="container-wide">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
            <div>
              <span className="overline mb-6 block">Misyonumuz</span>
              <h3
                className="text-[clamp(1.5rem,2.5vw,2rem)] leading-[1.2] tracking-[-0.02em] mb-6"
                style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
              >
                Güvenli, estetik ve ekonomik değer üreten yapılar inşa etmek.
              </h3>
              <p 
                className="text-[#8e8e93] leading-[1.9] text-[15px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                Her projemizde mühendislik mükemmelliğini, sürdürülebilirliği ve insan odaklı tasarımı ön planda tutarak, toplumun yaşam kalitesini yükseltiyoruz.
              </p>
            </div>
            <div>
              <span className="overline mb-6 block">Vizyonumuz</span>
              <h3
                className="text-[clamp(1.5rem,2.5vw,2rem)] leading-[1.2] tracking-[-0.02em] mb-6"
                style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
              >
                Türkiye'nin ve global pazarın güvenilen markası olmak.
              </h3>
              <p 
                className="text-[#8e8e93] leading-[1.9] text-[15px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                Şehirlerin siluetine kalıcı izler bırakan, nesiller boyu değer üreten projeler geliştirerek, sektörde referans noktası haline gelmek.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values - Horizontal list, no cards */}
      <section className="section-padding bg-[#d1d1d6]/20">
        <div className="container-wide">
          <div className="mb-16">
            <span className="overline mb-6 block">Değerlerimiz</span>
            <h2
              className="text-[clamp(2rem,4vw,3rem)] leading-[1.1] tracking-[-0.02em]"
              style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
            >
              Bizi biz yapan ilkeler
            </h2>
          </div>
          
          <div className="border-t border-[#d1d1d6]">
            {values.map((value, index) => (
              <div
                key={index}
                data-testid={`about-value-${index}`}
                className="grid grid-cols-12 gap-4 py-10 border-b border-[#d1d1d6]"
              >
                <div className="col-span-12 lg:col-span-3">
                  <h4
                    className="text-[20px] lg:text-[24px]"
                    style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
                  >
                    {value.title}
                  </h4>
                </div>
                <div className="col-span-12 lg:col-span-7 lg:col-start-5">
                  <p 
                    className="text-[#8e8e93] text-[15px] leading-[1.8]"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    {value.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 lg:py-32 bg-[#1a1a1a]">
        <div className="container-wide text-center">
          <h2
            className="text-[clamp(1.75rem,4vw,2.5rem)] leading-[1.15] tracking-[-0.02em] text-[#f2f2f7] mb-8"
            style={{ fontFamily: "var(--font-heading)", fontWeight: 400 }}
          >
            Birlikte çalışalım
          </h2>
          <p 
            className="text-[#d1d1d6]/70 text-[15px] mb-10 max-w-md mx-auto"
            style={{ fontFamily: "var(--font-body)" }}
          >
            Projenizi birlikte hayata geçirmek için ilk adımı atın.
          </p>
          <Link to="/iletisim" className="btn-hero-primary">
            İletişime Geçin
            <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
